import $ from 'jquery'

export default class adminFlowerSelect {
    constructor (element) {
        this.$element = $(element)

        this.targetInputId = this.$element.data('targetInputId')
        this.$targetInput = $('body').find(`input#${this.targetInputId}`)

        this.$modalForm = this.$element.find('form')
        this.$modalForm.on('submit', this.handleFormSubmit.bind(this))

        this.$firstFieldInForm = this.$modalForm.find('input, select, textarea').first()
        this.$firstFieldInForm.val(this.$targetInput.val())
    }

    handleFormSubmit (event) {
        event.preventDefault()
        event.stopPropagation()
        event.stopImmediatePropagation()
        this.$targetInput.val(this.$firstFieldInForm.val())
        this.$targetInput.trigger('change')
    }

    destroy () {

    }
}
